/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Select, Input } from 'antd';
import { getPopupContainer } from '../../../helpers/popUp';

const Styles = styled.div`
  width: 100%;
	.select-before {
		width: 90px;
	}
`

export default function Website({
  defaultDialCode = null,
  initialValue = null,
  onChange,
  allowClear = false,
  size = "middle",
  placeholder = null,
}) {
  const [schema, setSchema] = useState("http://");
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (initialValue) {
      try {
        const u = new URL(initialValue);
        setUrl(`${u.hostname}${u.pathname !== '/' ? u.pathname : ''}${u.hash}`);
        setSchema(`${u.protocol}//`);
      } catch {
        setUrl(initialValue);
      }
    }
  }, [initialValue])

  useEffect(() => {
    if (url) {
      if (onChange) onChange(`${schema}${url}`);
    }
  }, [schema, url]);


  return <Styles>
    <Input size={size} allowClear={allowClear} addonBefore={(
      <Select
        {...getPopupContainer()}
        size={size}
        defaultValue={schema}
        value={schema}
        onChange={val => setSchema(val)}
        className="select-before"
      >
        <Select.Option value="http://">http://</Select.Option>
        <Select.Option value="https://">https://</Select.Option>
      </Select>
    )} onChange={e => {
      try {
        const u = new URL(e.target.value);
        setUrl(`${u.hostname}${u.pathname !== '/' ? u.pathname : ''}${u.hash}`);
        setSchema(`${u.protocol}//`);
      } catch {
        setUrl(e.target.value);
      }
    }}
      defaultValue={url}
      value={url}
      autoComplete="new-password"
      type="url"
      placeholder={placeholder || 'www.example.com'}
    />
  </Styles>
};
